import AttributesContentBlock from 'models/common/content/block/attributes/AttributesContentBlock';

export default class TextContentBlockService {
	toModel(block) {
		return new AttributesContentBlock(block);
	}
}
